import { get_z3k_object_state } from 'z3k-parser/model/object/z3k-object';
import { useContext, useMemo } from 'react';
import { BoilerAdapterProtocol, HeatingCircuit, translateBoilerAdapterProcessor, translateBoilerAdapterType, } from 'z3k-config';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { BoilerControlType, } from 'console/climatic/setting-tabs/type';
import { Z3KSettings, Z3KSettingsState } from 'z3k-settings/provider/types';
export function useBoilerSegmentState(boiler_settings, boiler_configuration) {
    const { is_staff } = useContext(Z3KSettings);
    const { z3k_state } = useContext(Z3KSettingsState);
    const boiler_state = get_z3k_object_state(z3k_state, boiler_settings.id);
    const sensor_state = boiler_state?.target_sensor_id != null
        ? get_z3k_object_state(z3k_state, boiler_state.target_sensor_id)
        : undefined;
    const adapter_state = boiler_settings.corresponding_adapter?.id != null
        ? get_z3k_object_state(z3k_state, boiler_settings.corresponding_adapter?.id)
        : undefined;
    const is_fail = useMemo(() => boiler_state != null && HeatingCircuit.isFail(boiler_state), [boiler_state]);
    const boiler_status = useMemo(() => boiler_state != null
        ? HeatingCircuit.isFail(boiler_state)
            ? 'АВАРИЯ'
            : HeatingCircuit.isWorking(boiler_state)
                ? 'включен'
                : 'выключен'
        : 'неизвестно', [boiler_state]);
    const { hardware, adapter_type, processor } = useMemo(() => {
        if (boiler_settings?.corresponding_adapter?.serial?.builtIn) {
            const hardware = boiler_settings.corresponding_adapter.hardware;
            return {
                hardware,
                adapter_type: 'Встроенный',
                processor: null,
            };
        }
        return {
            hardware: boiler_settings.corresponding_adapter?.hardware ?? '',
            adapter_type: translateBoilerAdapterType(boiler_settings?.corresponding_adapter?.adapter_type ?? 0),
            processor: translateBoilerAdapterProcessor(boiler_settings.corresponding_adapter?.processor ?? 0),
        };
    }, [boiler_settings]);
    const serial_number = boiler_settings?.corresponding_adapter?.serial?.value;
    const boiler_models = useAppSelector((state) => state.boiler_models.data?.boiler_models) ?? [];
    const is_opentherm = useMemo(() => boiler_settings.corresponding_adapter?.type ===
        BoilerAdapterProtocol.OPENTHERM, [boiler_settings.corresponding_adapter?.type]);
    const is_ebus = useMemo(() => boiler_settings.corresponding_adapter?.type === BoilerAdapterProtocol.EBUS, [boiler_settings.corresponding_adapter?.type]);
    const show_hysteresis = useMemo(() => boiler_configuration.control_type !== BoilerControlType.DIGITAL, [boiler_configuration]);
    return {
        boiler_state,
        sensor_state,
        is_fail,
        boiler_status,
        adapter_state,
        is_staff,
        processor,
        adapter_type,
        hardware,
        serial_number,
        is_opentherm,
        show_hysteresis,
        boiler_models,
        is_ebus,
    };
}
